<template>
  <div class="brand">
    <innerBanner :banner="$t('brand.banner')" />
    <div class="wp4 swi-brand-wrap">
      <div class="swi-brand" v-if="brandList.length > 0">
        <div class="swiper-wrapper">
          <div v-for="item in brandList" :key="item.id" class="swiper-slide">
            <router-link
              :to="`/brandDetail/${item.attributes.slug}`"
              class="icon"
            >
              <img
                :src="item.attributes.thumbnail.data.attributes.url"
                :alt="
                  `Asian food wholesaler-OCM Foods Group + ${
                    item.brand_name
                  } Exclusive Distribution Partner in the US, 亚洲食品批发-美国华源食品集团 + ${
                    item.brand_name
                  }美国独家代理`
                "
              />
            </router-link>
            <router-link
              :to="`/brandDetail/${item.attributes.slug}`"
              class="txt"
            >
              <h3>{{ item.attributes.thumbnail_title }}</h3>
              <p>{{ item.attributes.thumbnail_subtitle }}</p>
            </router-link>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <section class="bot-banner">
      <img src="@/assets/images/ban3-2.jpg" alt="" />
    </section>
  </div>
</template>

<script>
import qs from 'qs'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import innerBanner from '@/components/innerBanner'

export default {
  name: 'brand',
  components: {
    innerBanner
  },
  data() {
    return {
      offsetTopBrand: 0,
      brandList: []
    }
  },
  activated() {
    window.scrollTo(0, this.offsetTopBrand || 0)
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'brandDetail')
      this.offsetTopBrand = document.documentElement.scrollTop
    else this.offsetTopBrand = 0
    next()
  },
  created() {
    this.getBrands()
  },
  methods: {
    async getBrands() {
      const queryInfo = qs.stringify(
        {
          locale: this.$i18n.locale,
          populate: 'deep'
        },
        {
          encodeValuesOnly: true
        }
      )
      const {
        data: { data: res }
      } = await this.$http.get(`${this.$strapiUrl}/brands?${queryInfo}`)
      this.brandList = [...res]
      setTimeout(() => {
        this.initSwiper()
      }, 0)
    },
    initSwiper: function() {
      var swiper = new Swiper('.swi-brand', {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        slidesPerView: 6,
        slidesPerGroup: 6,
        slidesPerColumn: 3,
        spaceBetween: 20,
        slidesPerColumnFill: 'row',
        breakpoints: {
          1199: {
            //当屏幕宽度小于等于1280
            slidesPerView: 4,
            spaceBetween: 21
          },
          768: {
            //当屏幕宽度小于等于768
            slidesPerView: 3,
            spaceBetween: 10
          }
        }
      })
    }
  },
  watch: {
    '$i18n.locale'() {
      this.getBrands()
    }
  }
}
</script>

<style scoped lang="scss">
//brand
.brand {
  .swi-brand-wrap {
    padding: 66px 0;
  }
  .swi-brand {
    position: relative;
    overflow: hidden;
    padding-bottom: 100px;
    .icon {
      display: block;
      cursor: pointer;
      padding-top: 100%;
      position: relative;
      overflow: hidden;
      background: $white2;
      border-radius: 50%;
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        width: 88px;
      }
    }
    .txt {
      display: block;
      cursor: pointer;
      padding-top: 8px;
      text-align: center;
      h3 {
        margin-bottom: 8px;
        @extend .semibold-16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p {
        @extend .regular-14px;
      }
    }
    .txt:hover {
      h3,
      p {
        color: $activeColor;
      }
    }

    ::v-deep {
      .swiper-pagination-bullet {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        opacity: 1;
        background: #dddbcb;
        position: relative;
        margin: 0 20px !important;
        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        -ms-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;
      }
      .swiper-pagination-bullet:after {
        content: '';
        width: 24px;
        height: 24px;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        border: 1px solid $activeColor;
        border-radius: 50%;
        opacity: 0;
        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        -ms-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;
      }
      .swiper-pagination-bullet-active.swiper-pagination-bullet {
        opacity: 1;
        background-color: $activeColor;
      }
      .swiper-pagination-bullet-active.swiper-pagination-bullet:after {
        opacity: 1;
      }
      .swiper-pagination.swiper-pagination-bullets {
        bottom: 15px;
      }
    }

    .swiper-slide {
      margin-top: 40px !important;
      order: 1 !important;
    }
  }
  .bot-banner {
    margin-bottom: 66px;
    display: flex;
    justify-content: center;
  }
}
@media only screen and (max-width: 1199px) {
  .brand .swi-brand-wrap {
    padding: 66px 20px;
  }
  .brand .swi-brand .icon img {
    width: 80px;
  }
}
@media only screen and (max-width: 767px) {
  .brand .swi-brand-wrap {
    padding: 0 20px 40px;
  }
  .brand .swi-brand .txt h3 {
    margin-bottom: 4px;
  }
  .swiper-slide {
    margin-top: 40px !important;
  }
}
</style>
